import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, MaskedBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class MaskedBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: "(123) 123-1234"
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="MaskedBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Default</Label>
								<MaskedBox name="phone" mask="(999) 999-9999" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Placeholder</Label>
								<MaskedBox name="placeholder" placeholder="Enter SSN" mask="999-99-9999" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Disabled</Label>
								<MaskedBox name="disabled" disabled={true} mask="(999) 999-9999" />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label >Preset</Label>
								<MaskedBox name="preset" mask="(999) 999-9999" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Required</Label>
								<MaskedBox name="required" required  mask="(999) 999-9999" />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default MaskedBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/MaskedBoxDemo.js